import { AssetApprovalStatus } from '@casops/store/apis/assetApprovalsApi';
import CustomNotification from '@cas/components/data-display/custom-notification/CustomNotification';
import { ReactElement } from 'react';
import { BadgeStatus } from '@cas/components/data-display/badge-dot/BadgeDot';
import { useTranslation } from 'react-i18next';

const badgeStatusMap: Record<AssetApprovalStatus, BadgeStatus> = {
  [AssetApprovalStatus.PreApproved]: BadgeStatus.Healthy,
  [AssetApprovalStatus.ApprovalRequired]: BadgeStatus.Caution,
  [AssetApprovalStatus.PreApprovedInvalid]: BadgeStatus.Danger,
  [AssetApprovalStatus.Conflict]: BadgeStatus.Danger,
};

interface ApprovalStatusNotificationProps {
  status: AssetApprovalStatus;
}

export const ApprovalStatusNotification = ({
  status,
}: ApprovalStatusNotificationProps): ReactElement => {
  const { t } = useTranslation();

  return (
    <CustomNotification
      title={t(`AssetApprovalStatus.${status}`)}
      message={t(`AssetApprovalStatusMessage.${status}`)}
      badgeStatus={badgeStatusMap[status]}
    />
  );
};

export default ApprovalStatusNotification;
